import { Injectable } from '@angular/core';
import { IHolding } from '../../models/holding.model';
import { ISelectList } from '../../models/select-list.model';
import { ApiService } from '../api/api.service';
import { UserService } from '../user/user.service';

@Injectable()
export class HoldingService {
  holding: IHolding;
  holdings: Array<IHolding> = [];

  constructor(
    private apiService: ApiService,
    private userService: UserService
  ) {}

  isNameUnique(businessId: number, name: string, id: number): Promise<boolean> {
    let url = `v1/businesses/${businessId}/holdings:nameUnique?name=${name}`;
    if (id) {
      url = `${url}&holdingId=${id}`;
    }

    return this.apiService.get(url);
  }

  loadHoldings(businessId: number): Promise<IHolding[]> {
    return this.apiService
      .get(`v1/businesses/${businessId}/holdings`)
      .then((response: Array<IHolding>) => {
        this.holdings = response;
        return response;
      });
  }

  saveHoldings(businessId: number, holdings: IHolding[]) {
    return this.apiService
      .post(`v1/businesses/${businessId}/holdings`, holdings)
      .then((response: Array<IHolding>) => {
        this.holdings = response;
        return response;
      });
  }

  getLookups(businessId: number): Promise<ISelectList[]> {
    return this.apiService.get(`v1/businesses/${businessId}/holdings`);
  }

  deleteHolding(businessId: number, holding: IHolding) {
    return this.apiService
      .delete(`v1/businesses/${businessId}/holdings/${holding.id}`)
      .then(() => {
        this.holdings = this.holdings.filter(h => h.id !== holding.id);
      });
  }
}
